import React, { useEffect, useRef, useState } from 'react'
import HeaderUser from '../components/homePage/HeaderUser'
import FooterPage from '../components/homePage/FooterPage'
import InboxLeftSideBar from '../components/inbox/InboxLeftSideBar'
import { useSelector } from 'react-redux';
import { ageCalculate, checkIncomeShowHide, checkNameShowHide, decimalToFeetInches, nameMask } from '../utils/utils'
import { Link, useNavigate } from 'react-router-dom';
import ConfirmPopup from '../components/homePage/ConfirmPopup';
import Cookies from "js-cookie";
import SettingsSidebar from '../components/settings/SettingsSidebar';
import { annualIncomeMap } from '../utils/Helper';

function DobRequestList() {
    const token = JSON.parse(decodeURIComponent(Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser") || null));
    const navigate = useNavigate()
    const [pageTitle, setPageTitle] = useState("");
    const { userDetailLogin } = useSelector((state) => state.auth);
    const [meneberList, setMemberList] = useState([]);
    const modalConfirmRef = useRef(null)
    const modalInstanceConfirm = useRef(null);
    const [popupMessage, setPopupMessage] = useState("")
    const [partnerValueId, setPartnerValueId] = useState("")
    const [memberValueId, setMemberValueId] = useState("")
    const [memberValueStatus, setMemberValueStatus] = useState("")
    const [showButton, setShowButton] = useState(1)
    const endpoint = window.location.pathname.split("/").filter(Boolean).pop();

    const [planDetailUser, setPlanDetailUser] = useState({})
    const [totalUserSentInterest, setTotalUserSentInterest] = useState(0)
    const [expiryDate, setExpiryDate] = useState(false)
    const [totalUserView, setTotalUserView] = useState(0)
    const [blurPhoto, setBlurPhoto] = useState(0)
    const [loginProps, setLoginProps] = useState(null);
    const modalInstance = useRef(null);
    const modalInstanceSuccess = useRef(null);
    const [successMessage, setSuccessMessage] = useState("")

    const title = {
        sent: "Request Sent",
        accepted: "Accepted",
        received: "Received",
        decline: "Decline"
    };

    // request
    // request
    const requestPhoto = (member_id, index) => {

        setLoginProps('reload');
        if (userDetailLogin?._id) {

            sendRequestPhoto(member_id, index);

        } else {

            modalInstance.current?.show();

            return;

        }

    }

    const sendRequestPhoto = async (member_id, index) => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL_API}/api/user/send-photo-request`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`
                    },
                    body: JSON.stringify({
                        member_id: member_id,
                        //member_id : member_id 
                    }),
                }
            );

            const data = await response.json();

            if (response.ok) {
                // console.log("Interest sent successfully:", data);
                setSuccessMessage("Request a photo send successfully.")
                modalInstanceSuccess.current?.show();
                setTimeout(() => {
                    modalInstanceSuccess.current?.hide();
                }, 2000)
                meneberList((prevData) => {
                    const updated = [...prevData];
                    updated[index] = {
                        ...updated[index],
                        photo_request_check: true,
                    };
                    updated[index] = {
                        ...updated[index],
                        photo_request_status: null,
                    };
                    return updated;
                });

            } else {
                console.error("Failed to send request photo:", data.message || data);
            }
        } catch (error) {
            console.error("Error while sending request photo:", error);
        }

    }
    // list fetch
    const listMember = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/dob-request`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    //pageType: pageType,
                    //member_id: userDetailLogin._id,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                setMemberList(data.data);
            } else {
                console.error("Error fetching members:", data.error || data.message);
            }
        } catch (error) {
            console.error("Fetch failed:", error);
        }
    };


    //cancel request
    const removeShortlistButton = async (id, val) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/change-send-birth-request-status`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                },
                body: JSON.stringify({
                    //member_id: userDetailLogin._id,
                    request_id: id,
                    status: val
                }),
            });

            const data = await response.json();

            if (response.ok) {
                listMember()
                //setPartnerValueId("")
                //setMemberList();
                //console.log("Cancel successful:", data);
            } else {
                console.error("Error fetching members:", data.error || data.message);
            }
        } catch (error) {
            console.error("Fetch failed:", error);
        }
    }



    useEffect(() => {

        listMember();

        document.title = 'Dob Request';
    }, []);


    useEffect(() => {
        // Initialize Bootstrap modal once (after first render)
        const modalConfirmEl = document.getElementById("confirmPopupId");
        if (modalConfirmEl) {
            modalInstanceConfirm.current = new window.bootstrap.Modal(modalConfirmEl);
        }


    }, []);
    useEffect(() => {
        // Initialize Bootstrap modal once (after first render) loginModal
        const modalEl = document.getElementById("loginModal");
        if (modalEl) {
            modalInstance.current = new window.bootstrap.Modal(modalEl);
        }
    }, []);


    const removeShortlist = async (e, partnerId, val) => {
        //console.log(partnerId)
        setPartnerValueId(partnerId)
        setMemberValueStatus(val)
        setShowButton(1)
        if (val === 1) {
            setPopupMessage('are you sure you want to accept dob request?')
        } else {
            setPopupMessage('are you sure you want to reject dob request?')
        }
        modalInstanceConfirm.current?.show();
    };



    const yesNoButton = (value) => {

        //console.log('confirm', value)
        if (value === 'Yes') {
            //console.log('yes', partnerValueId)
            if (memberValueStatus === 1) {
                removeShortlistButton(partnerValueId, 1)
            } else {
                removeShortlistButton(partnerValueId, 0)
            }
        }
        modalInstanceConfirm.current?.hide();
    }





    const yesNoStatusButton = (value) => {


        if (value === 'Yes') {
            //console.log('yes', partnerValueId)

        }
        modalInstanceConfirm.current?.hide();
    }


    const fetchUserDetailMatch = async (userId) => {

        const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/user-detail-all/${userId}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`
            },
        });

        const data = await res.json();
        //console.log(data)
        if (data.status) {

            //console.log('interest', data.data[0])
            const isExpired = new Date(data.data[0].plan_detail?.expiry_date) < new Date();

            setExpiryDate(isExpired)
            setTotalUserSentInterest(data.data[0].interest_user)
            setPlanDetailUser(data.data[0].plan_detail)
            setTotalUserView(data.data[0].total_user_view)


            //let blurPhoto = 0 
            if (!data.data[0]?.plan_detail || Object.keys(data.data[0]?.plan_detail).length === 0 || data.data[0]?.plan_detail?.plan_id?.name === 'Basic' || (data.data[0]?.plan_detail?.plan_id?.name === 'Gold' && data?.data[0]?.interest_user > parseInt(data.data[0]?.plan_detail?.send_interest)) || (data.data[0]?.plan_detail?.plan_id?.name === 'Premium' && data?.data[0]?.interest_user > parseInt(data.data[0]?.plan_detail?.send_interest)) || (expiryDate && (data.data[0]?.plan_detail?.plan_id?.name === 'Gold' || data.data[0]?.plan_detail?.plan_id?.name === 'Premium'))) {
                //console.log('blur photo')
                //blurPhoto = 1
                setBlurPhoto(1)
            }


        }

    }


    useEffect(() => {

        if (userDetailLogin?._id) {
            fetchUserDetailMatch(userDetailLogin?._id)
        }

    }, [userDetailLogin])



    const showPopUpButton = (e, url) => {
        e.preventDefault()
        setLoginProps(url);
        if (userDetailLogin?._id) {
            //console.log(planDetailUser?.profile_view)
            if (planDetailUser?.profile_view === 'unlimited') {

                navigate(url)

            } else if (!planDetailUser || (totalUserView > parseInt(planDetailUser?.profile_view))) {
                setPopupMessage(`You're currently on the ${planDetailUser?.plan_id?.name || 'Basic'} plan. Kindly upgrade your plan to continue.`)
                modalInstanceConfirm.current?.show();

            } else {

                navigate(url)

            }

        }


    }


    return (
        <>
            <HeaderUser />
            <ConfirmPopup ref={modalConfirmRef} message={popupMessage} yesNoButton={showButton === 2 ? yesNoStatusButton : yesNoButton} />



            <section className="inrbnr">
                <div className="container-fluid con-flu-padd">
                    <div className="inrbnrContent">
                        <h1>View DOB Request</h1>
                        <ul className="inrbrnNav">
                            <li>
                                <Link to="/dashboard">
                                    <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/home.png`} alt="home icon" />
                                </Link>
                                <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/arrows.png`} alt="arrows icons" />
                            </li>

                            <li>
                                <Link to="#">View DOB Request</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section>
                <div className="register-sec ">
                    <div className="container-fluid con-flu-padd  ">
                        <div className="mx-2  ">
                            <div className="row pb-20 pt-40">
                                <div className="col-md-3 p-0 ">
                                    <SettingsSidebar />
                                    <div className="img-settings">
                                        <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/setting-group.png`} alt="" />
                                    </div>
                                </div>
                                <div className="col-md-9 set-pad-lef ">
                                    <div className="heading-settings">
                                        <h3>View DOB Request</h3>
                                    </div>
                                    {meneberList && meneberList.length > 0 ? (
                                        meneberList.map((member, index) => {
                                           

                                            let profilePhoto;
                                            let profilePhotoBlur;
                                            let profilePhotoShow;
                                            if (member?.user_id?.profile_photo === 1) {
                                                profilePhoto = member?.user_id?.photo
                                                profilePhotoShow = member?.user_id?.photo
                                                profilePhotoBlur = member?.user_id?.photo_blur
                                                if (blurPhoto === 1) {
                                                    profilePhoto = member?.user_id?.photo_blur
                                                }
                                            } else if (member?.user_id?.profile_photo === 2) {
                                                profilePhoto = member?.user_id?.photo1
                                                profilePhotoShow = member?.user_id?.photo1
                                                profilePhotoBlur = member?.user_id?.photo1_blur
                                                if (blurPhoto === 1) {
                                                    profilePhoto = member?.user_id?.photo1_blur
                                                }
                                            } else if (member?.user_id?.profile_photo === 3) {
                                                profilePhoto = member?.user_id?.photo2
                                                profilePhotoShow = member?.user_id?.photo2
                                                profilePhotoBlur = member?.user_id?.photo2_blur
                                                if (blurPhoto === 1) {
                                                    profilePhoto = member?.user_id?.photo2_blur
                                                }
                                            } else if (member?.user_id?.profile_photo === 4) {
                                                profilePhoto = member?.user_id?.photo3
                                                profilePhotoShow = member?.user_id?.photo3
                                                profilePhotoBlur = member?.user_id?.photo3_blur
                                                if (blurPhoto === 1) {
                                                    profilePhoto = member?.user_id?.photo3_blur
                                                }
                                            } else if (member?.user_id?.profile_photo === 5) {
                                                profilePhoto = member?.user_id?.photo4
                                                profilePhotoShow = member?.user_id?.photo4
                                                profilePhotoBlur = member?.user_id?.photo4_blur
                                                if (blurPhoto === 1) {
                                                    profilePhoto = member?.user_id?.photo4_blur
                                                }
                                            } else {
                                                profilePhoto = member?.user_id?.photo
                                                profilePhotoShow = member?.user_id?.photo
                                                profilePhotoBlur = member?.user_id?.photo_blur
                                                if (blurPhoto === 1) {
                                                    profilePhoto = member?.user_id?.photo_blur
                                                }
                                            }

                                            return (
                                                <>
                                                    <div className="col-12 mb-4" key={member._id || index} >
                                                        <div className="res-profiles inboxcont">
                                                            <div className="row">
                                                                <div className="col-12 padi-res">
                                                                    <div className="row">
                                                                        <div className="col-lg-8 col-md-9  ic-ver-res">
                                                                            <ul>
                                                                                <li>

                                                                                    <h4>
                                                                                        <Link to="#" onClick={(e) => showPopUpButton(e, `/profile-details/${member?.user_id?._id}`)}>
                                                                                            {checkNameShowHide(member?.user_id?.profileSettings?.name_show, planDetailUser) ? member?.user_id?.name : nameMask(member?.user_id?.name)}{" "}
                                                                                        </Link>
                                                                                    </h4>
                                                                                </li>
                                                                                <li>
                                                                                    <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/verified.png`} alt="" />
                                                                                </li>
                                                                                <li className="profil-id-re">( ID :&nbsp;{member.user_id?.profile_id} )</li>
                                                                            </ul>
                                                                        </div>
                                                                        <div className="col-lg-4 col-md-3 res-fl   ">
                                                                            <ul className="justify-content-lg-end">
                                                                                <li>
                                                                                    <img src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/calender.png`} alt="" />
                                                                                </li>
                                                                                <li className=""> {new Date(member.createdAt).toLocaleDateString("en-GB", {
                                                                                    day: "2-digit",
                                                                                    month: "short"
                                                                                })}</li>
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 pad-res-2">
                                                                    <div className="row">
                                                                        <div className="col-lg-3 col-xl-2 col-md-4 pe-lg-0">
                                                                            <div className='inboximg'>

                                                                                {( member?.user_id?.profileSettings == null ||
                                                                                    member?.user_id?.profileSettings?.photo_show === 2 ||
                                                                                    (member?.photo_request_check  &&
                                                                                        member?.photo_request_status === 1)
                                                                                ) && (
                                                                                        <Link
                                                                                            to="#"
                                                                                            onClick={(e) =>
                                                                                                showPopUpButton(e, `/profile-details/${member?.user_id?._id}`)
                                                                                            }
                                                                                        >
                                                                                            <img
                                                                                                src={
                                                                                                    profilePhotoShow
                                                                                                        ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhotoShow}`
                                                                                                        : member?.user_id?.gender === "Male"
                                                                                                            ? "assets/img/no-image-male.jpg"
                                                                                                            : "assets/img/no-image-female.jpg"
                                                                                                }
                                                                                                alt=""

                                                                                            />
                                                                                        </Link>
                                                                                    )}

                                                                                {(
                                                                                   member?.photo_request_status != 1 &&  member?.user_id?.profileSettings?.photo_show === 1 ||
                                                                                   member?.photo_request_status != 1 && blurPhoto === 1
                                                                                ) && (
                                                                                        <>


                                                                                            {member?.user_id?.profileSettings?.photo_show === 1 ? (
                                                                                                <>
                                                                                                    {!member?.user_id?.photo_request_check && (
                                                                                                        <Link
                                                                                                            to="#"
                                                                                                            onClick={(e) => {
                                                                                                                e.preventDefault();
                                                                                                                requestPhoto(member?.user_id?._id, index);
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* Request a Photo */}
                                                                                                        </Link>
                                                                                                    )}
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <span>
                                                                                                        Visible to <br />
                                                                                                        Premium Members
                                                                                                    </span>
                                                                                                    <a href="/membership-plan">View Plans</a>
                                                                                                </>
                                                                                            )}


                                                                                            <Link
                                                                                                to="#"
                                                                                                onClick={(e) =>
                                                                                                    showPopUpButton(e, `/profile-details/${member?.user_id?._id}`)
                                                                                                }
                                                                                            >
                                                                                                <img
                                                                                                    src={
                                                                                                        profilePhotoBlur
                                                                                                            ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhotoBlur}`
                                                                                                            : member?.user_id?.gender === "Male"
                                                                                                                ? "assets/img/no-image-male.jpg"
                                                                                                                : "assets/img/no-image-female.jpg"
                                                                                                    }
                                                                                                    alt=""
                                                                                                />
                                                                                            </Link>
                                                                                        </>
                                                                                    )}

                                                                                {member?.user_id?.profileSettings?.photo_show === 0 && (
                                                                                    <Link
                                                                                        to="#"
                                                                                        onClick={(e) =>
                                                                                            showPopUpButton(e, `/profile-details/${member?.user_id?._id}`)
                                                                                        }
                                                                                    >
                                                                                        <img
                                                                                            src={
                                                                                                profilePhoto
                                                                                                    ? `${process.env.REACT_APP_BASE_URL_IMAGE}${profilePhoto}`
                                                                                                    : member?.user_id?.gender === "Male"
                                                                                                        ? "assets/img/no-image-male.jpg"
                                                                                                        : "assets/img/no-image-female.jpg"
                                                                                            }
                                                                                            alt=""
                                                                                            width={223}
                                                                                        />
                                                                                    </Link>
                                                                                )}

                                                                            </div>

                                                                        </div>
                                                                        <div className="col-lg-5 col-xl-7 col-md-8 col-xs-12">
                                                                            <div className="row">
                                                                                <div className="col-xl-5 col-lg-12">
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Age / Height</span>:
                                                                                        {(member?.user_id?.dob || member?.user_id?.height)
                                                                                            ? `${member?.user_id?.dob ? ageCalculate(member?.user_id?.dob) : ""}${member?.user_id?.dob && member?.user_id?.height ? ", " : ""}${member?.user_id?.height ? decimalToFeetInches(member?.user_id.height) : ""}`
                                                                                            : ""}
                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Religion</span>: {member?.user_id?.religion?.name}
                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Cast</span>: {member?.user_id?.caste?.name}
                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Gotra</span>: {member?.user_id?.gotra?.name}
                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Occupation</span>:
                                                                                        { member?.user_id?.occupation?.name }
                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Location</span>:
                                                                                        {[member?.user_id?.loc_state?.name, member?.user_id?.loc_city?.name].filter(Boolean).join(", ")}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-xl-6 col-lg-12">
                                                                                    <div className="profiledata-rowss marg-to d-flex align-items-start">
                                                                                        <span className="fieldname">Education</span>:
                                                                                        {member.user_id?.highest_degree?.name}
                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Manglik</span>: {member?.user_id?.manglik}
                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Marital Status</span>
                                                                                        :  {member?.user_id?.marital_status?.name}
                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Income</span>:  
                                                                                        {
                                                                                            checkIncomeShowHide(member?.user_id?.profileSettings?.work_with_show, planDetailUser)
                                                                                                ? (member?.user_id?.annual_income 
                                                                                                    ? annualIncomeMap(member.user_id.annual_income) 
                                                                                                    : "")
                                                                                                : nameMask(member?.user_id?.annual_income)
                                                                                            }{" "}

                                                                                    </div>
                                                                                    <div className="profiledata-rowss d-flex align-items-start">
                                                                                        <span className="fieldname">Job</span>: {member?.user_id?.working_with?.name}
                                                                                    </div>
                                                                                </div>
                                                                            </div>







                                                                        </div>
                                                                        <div className="col-lg-4 col-xs-12 col-md-6 col-xl-3">
                                                                            <div className="bg-ic-ress text-center px-3">
                                                                                <div className="butt-res-acc">
                                                                                    <button className="accept">
                                                                                        {member.status === 1 ? 'Accepted' :
                                                                                            <Link to="#" onClick={(e) => removeShortlist(e, member?._id, 1)} data-discover="true">
                                                                                                <img
                                                                                                    alt=""
                                                                                                    src="https://vivashri.com/assets/img/icons/check-circle_svgrepo.com.png"
                                                                                                />
                                                                                                Accept
                                                                                            </Link>
                                                                                        }
                                                                                    </button>
                                                                                    <br />
                                                                                    <button className="delet">
                                                                                        <Link to="#" onClick={(e) => removeShortlist(e, member?._id, 0)} data-discover="true">
                                                                                            <img
                                                                                                alt=""
                                                                                                src="https://vivashri.com/assets/img/icons/delete_svgrepo.com.png"
                                                                                            />
                                                                                            Reject
                                                                                        </Link>
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </>

                                            )



                                        })
                                    ) : (
                                        <div className="profilelist-box d-md-flex align-items-md-start justify-content-md-start mb-2">
                                            No profile found
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <FooterPage />
        </>
    )
}

export default DobRequestList
